// @flow
export const getHitsPerPageItems = (pages: Array<number>) =>
  pages.map(page => ({ label: page.toString(), value: page }));
